export const BACKGROUND_COLOR = 'var(--brand-color-canvas-subtle)'
export const DARK_BACKGROUND_COLOR = '#0F1511'
export const GRID_LINE_COLOR = 'var(--brand-color-border-subtle)'
export const DARK_GRID_LINE_COLOR = '#262C28'
export const COLORS = ['#5FED83', '#C898FD', '#DA7210', '#8DD6FF', '#0FBF3E', '#5FB9FF', '#08872B'] as const
